module.exports = __webpack_public_path__ + "static/sidemail-report-a2cc9c2aaecd11b0bc7b6827d654de5f.webp";